(function () {
  function initDrillDown() {
    const flatItems = document.querySelectorAll('.menu-drawer__list-item--flat');
    flatItems.forEach((item) => {
      if (item.dataset.drillInit) return;
      item.dataset.drillInit = 'true';

      const parentLink = item.querySelector('a.menu-drawer__menu-item--mainlist');
      const childList = item.querySelector('ul.menu-drawer__menu--childlist');
      if (!parentLink || !childList) return;

      if (!parentLink.querySelector('.drill-down-arrow')) {
        const arrow = document.createElement('span');
        arrow.className = 'drill-down-arrow';
        arrow.textContent = '→';
        parentLink.appendChild(arrow);
      }

      parentLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const menuDrawer = document.querySelector('.menu-drawer__inner-container') || document.querySelector('.menu-drawer');
        if (!menuDrawer) return;

        const panel = document.createElement('div');
        panel.className = 'drill-down-panel';

        const header = document.createElement('div');
        header.className = 'drill-down-header';

        const backBtn = document.createElement('button');
        backBtn.className = 'drill-down-back';
        backBtn.textContent = '← ' + (parentLink.querySelector('.menu-drawer__menu-item-text') || parentLink).textContent.trim().replace('→', '').trim();
        backBtn.addEventListener('click', function () {
          panel.remove();
        });

        header.appendChild(backBtn);
        panel.appendChild(header);

        const clonedList = childList.cloneNode(true);
        panel.appendChild(clonedList);

        menuDrawer.appendChild(panel);
        requestAnimationFrame(() => {
          panel.classList.add('drill-down-panel--visible');
        });
      });
    });
  }

  // Ejecutar cuando se abre el drawer
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[aria-controls]');
    if (toggle) {
      setTimeout(initDrillDown, 300);
    }
  });

  // También al cargar
  document.addEventListener('DOMContentLoaded', initDrillDown);
  setTimeout(initDrillDown, 1000);
})();
